import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { PosGraduacaoService } from '@/core/api/sicom-api/servicos/pessoa-fisica/pos-graduacao/pos-graduacao.service';
import { ServicoAnexoService } from '@/core/api/sicom-api/servicos/shared/servico-anexo.service';
import type { PosGraduacaoRequest, PosGraduacaoResponse } from '@/core/api/sicom-api/servicos/pessoa-fisica/pos-graduacao/pos-graduacao.model';

@Injectable({ providedIn: 'root' })
export class PosGraduacaoServicosService {
    constructor(
        private api: PosGraduacaoService,
        private servicoAnexo: ServicoAnexoService
    ) {}

    consultar(params: PosGraduacaoRequest, context?: HttpContext): Observable<PosGraduacaoResponse> {
        if (!params?.numeroProtocolo || !params?.anoProtocolo || !params?.ufCrm) {
            return throwError(() => new Error('Parâmetros inválidos: numeroProtocolo, anoProtocolo e ufCrm são obrigatórios.'));
        }

        return this.api.consultar(params, context);
    }

    visualizarAnexo(idAnexo: string, context?: HttpContext): Observable<Blob> {
        const id = idAnexo?.trim();
        if (!id) {
            return throwError(() => new Error('Id do anexo não informado.'));
        }

        return this.servicoAnexo.visualizarAnexo(id, context);
    }
}
